export const allListings = [

  {
    id: 'kyme-studio',
    listingType: 'clinica',
    name: 'Kymè Studio',
    isFeatured: true,
    tier: 3,
    description: 'Kymè Studio ofrece tratamientos de última generación para el cuidado facial y corporal, con tecnología avanzada y atención personalizada para resultados excepcionales.',
    specialties: ['Depilación Láser', 'Tratamientos Faciales', 'Cavitación'],
    city: 'Rosario',
    province: 'Santa Fe',
    experience: '10+ años',
    hours: 'Lun-Vie: 9 AM - 8 PM, Sáb: 9 AM - 1 PM',
    rating: 4.9,
    contact: {
      phone: '+54 341 555-1234',
      email: 'contacto@kymestudio.com.ar',
      whatsapp: 'https://wa.me/5493415551234',
      website: 'https://kymestudio.com.ar',
      address: 'Mariano Moreno 1739, Rosario, Santa Fe'
    },
    additionalServices: ['Radiofrecuencia', 'Mesoterapia', 'Peelings Químicos', 'Nutrición'],
    calendarLink: 'https://link.vastfunnel.com/widget/booking/ZyffHAxW8JNBgMMUFm4X',
    crmAccess: true,
    socialMediaManagement: true,
    images: ['https://sspark.genspark.ai/cfimages?u1=BhZKSBfJxM1pc86cf5XuJChe7sDxD%2BtunEbRlPretfIrpzOPcC3EIg%2FSsM6MxbaUXxJjIbxDrrmBs%2BNz7eRSrwbTwrFYRuEI33YZyJOBKWQUwharadms5ChD5Xfl5JIldAmCMoICsWAZv1%2FCiyaa5ql7qes%3D&u2=2XOlvx1mpPdov2QJ&width=2560', 'https://placehold.co/400x250/B8860B/FFFFFF?text=Kyme+2', 'https://placehold.co/400x250/F5F5F5/333333?text=Kyme+3']
  },
  {
    id: 'dra-brarda',
    listingType: 'medicina-estetica',
    name: 'Dra. Brarda Medicina Estética',
    isFeatured: true,
    tier: 3,
    description: 'Consultorio de medicina estética especializado en tratamientos anti-age, rellenos y procedimientos no invasivos con enfoque en resultados naturales y armoniosos.',
    specialties: ['Inyectables y Rellenos', 'Botox', 'Hilos Tensores'],
    city: 'Rosario',
    province: 'Santa Fe',
    experience: '15+ años',
    hours: 'Lun-Vie: 10 AM - 7 PM',
    rating: 5.0,
    contact: {
      phone: '+54 341 679-0706',
      email: 'info@drabrarda.com',
      whatsapp: 'https://wa.me/5493413078080',
      website: 'https://drabrarda.com',
      address: 'Urquiza 1357, Rosario, Santa Fe'
    },
    additionalServices: ['Plasma Rico en Plaquetas', 'Laser CO2 Fraccionado', 'Escleroterapia'],
    calendarLink: 'https://link.vastfunnel.com/widget/booking/ZyffHAxW8JNBgMMUFm4X',
    crmAccess: true,
    socialMediaManagement: true,
    images: ['https://placehold.co/400x250/5E6C84/FFFFFF?text=Brarda+1', 'https://placehold.co/400x250/B8860B/FFFFFF?text=Brarda+2', 'https://placehold.co/400x250/F5F5F5/333333?text=Brarda+3']
  },
  {
    id: 'floria-beauty',
    listingType: 'salon',
    name: 'Floria Beauty Boosters',
    isFeatured: false,
    tier: 2,
    description: 'Salón de belleza que ofrece una amplia gama de servicios para realzar tu belleza natural, desde cuidado de uñas hasta tratamientos de depilación.',
    specialties: ['Manicuría y Pedicuría', 'Depilación con Cera', 'Estética de Pestañas y Cejas'],
    city: 'Rosario',
    province: 'Santa Fe',
    experience: '5+ años',
    hours: 'Mar-Sáb: 10 AM - 8 PM',
    rating: 4.7,
    contact: {
      phone: '+54 341 444-5555',
      email: 'info@floriabeauty.com',
      whatsapp: 'https://wa.me/5493414445555',
      website: 'https://floriabeauty.com',
      address: 'Italia 1200, Rosario, Santa Fe'
    },
    images: ['https://placehold.co/400x250/F5F5F5/333333?text=Floria+1', 'https://placehold.co/400x250/FFFFFF/333333?text=Floria+2']
  },
  {
    id: 'las-rosas-clinica',
    listingType: 'clinica',
    name: 'Las Rosas Clínica Estética',
    isFeatured: true,
    tier: 2,
    description: 'Clínica líder en Córdoba, con profesionales altamente capacitados para tratamientos corporales, faciales y depilación láser. Compromiso con la salud y belleza.',
    specialties: ['Tratamientos Corporales', 'Depilación Láser', 'Dermatología Estética'],
    city: 'Córdoba',
    province: 'Córdoba',
    experience: '12+ años',
    hours: 'Lun-Vie: 8 AM - 8 PM, Sáb: 8 AM - 12 PM',
    rating: 4.8,
    contact: {
      phone: '(0351) 481-4409',
      email: 'contacto@lasrosasclinica.com.ar',
      whatsapp: 'https://wa.me/5493516977847',
      website: 'https://lasrosasclinica.com.ar',
      address: 'Luis de Tejeda 4445, Cerro de las Rosas, Córdoba'
    },
    images: ['https://sspark.genspark.ai/cfimages?u1=ek%2B2dVzeLsrGiG58ygy3EMRujWhIROw3u9sGqyjEun9gExfMbSbJeQi%2BrghOoMXe2ekLZ109AUbKKqN61LVo6VfXsKUJ8tcCHBwRzVU4msTSFVNvxypPoJ2q7I1O6sh%2FGRJcBQ9j2U6SoyuoQz1ojw%3D%3D&u2=skap%2BJaNkh66nr6e&width=2560', 'https://sspark.genspark.ai/cfimages?u1=L3wmHFKQozXpsiC6EdWrTM2aDNu9w%2FHLmKT89OTx31SvGCjGjeQFlqTOKjK%2FEpAxVhTSrGeac2o%2FpX5jANM%2BhSPKXiuTXCHPfB6MHOdGgldY9BJuY9xFgQ%3D%3D&u2=TA%2FyXXQRqLgCTgiY&width=2560']
  },
  {
    id: 'isis-depilacion',
    listingType: 'salon',
    name: 'ISIS Depilación Láser',
    isFeatured: false,
    tier: 1,
    description: 'Centro especializado en depilación láser, con tecnología de vanguardia y paquetes personalizados para hombres y mujeres.',
    specialties: ['Depilación Láser'],
    city: 'La Plata',
    province: 'Buenos Aires',
    experience: '7+ años',
    hours: 'Lun-Sáb: 9 AM - 8 PM',
    rating: 4.7,
    contact: {
      phone: '+54 221 422-3344',
      email: 'info@isisdepilacion.com',
      whatsapp: 'https://wa.me/5492214223344',
      website: 'https://isisdepilacion.com.ar',
      address: 'Calle 54 #710 e/ 9 y 10, La Plata, Buenos Aires'
    },
    images: ['https://sspark.genspark.ai/cfimages?u1=C1%2F48qYt4OaIwHbODdfXtM1S%2FDQR8Ty40abJtqXvHH9vMA2Ggg7RFNHel2RBc5EZeSve%2BEiYUMEEQni4uPUs2CkRGT%2BgZuj%2BrjkJ&u2=zfp3u1qamh7PQ6VD&width=2560', 'https://sspark.genspark.ai/cfimages?u1=ob8AWtdvvAxssK2cGP8XjiWunqUsz%2FAKpz3AT%2FmLb0lF315G0862bEkS5hXntvg1sxD%2FelG95isyFjLInb%2BS5BSsgQ93ZG2R1FuW&u2=CgCH0k1NnIBwdFie&width=2560']
  },
  {
    id: 'spa-natural-mendoza',
    listingType: 'spa',
    name: 'Spa Natural Mendoza',
    isFeatured: true,
    tier: 3,
    description: 'Un oasis de relajación y bienestar en el corazón de Mendoza, ofreciendo tratamientos holísticos y experiencias de spa inolvidables.',
    specialties: ['Masajes Terapéuticos', 'Tratamientos Corporales', 'Bienestar'],
    city: 'Mendoza',
    province: 'Mendoza',
    experience: '8+ años',
    hours: 'Mar-Dom: 9 AM - 9 PM',
    rating: 4.9,
    contact: {
      phone: '+54 261 777-8888',
      email: 'reservas@spanatural.com.ar',
      whatsapp: 'https://wa.me/5492617778888',
      website: 'https://spanaturalmendoza.com',
      address: 'Av. Arístides Villanueva 1450, Mendoza, Mendoza'
    },
    additionalServices: ['Circuitos Hídricos', 'Rituales de Aromaterapia', 'Yoga & Meditación', 'Terapias Alternativas'],
    calendarLink: 'https://link.vastfunnel.com/widget/booking/ZyffHAxW8JNBgMMUFm4X',
    crmAccess: true,
    socialMediaManagement: true,
    images: ['https://placehold.co/400x250/5E6C84/FFFFFF?text=Spa+1', 'https://placehold.co/400x250/B8860B/FFFFFF?text=Spa+2', 'https://placehold.co/400x250/F5F5F5/333333?text=Spa+3']
  },
  {
    id: 'belleza-salta',
    listingType: 'salon',
    name: 'Belleza del Norte Salta',
    isFeatured: false,
    tier: 2,
    description: 'Salón integral de belleza con servicios de peluquería, manicuría y tratamientos faciales, utilizando productos de alta calidad.',
    specialties: ['Manicuría y Pedicuría', 'Cortes y Peinados', 'Tratamientos Faciales'],
    city: 'Salta',
    province: 'Salta',
    experience: '6+ años',
    hours: 'Mar-Sáb: 9 AM - 7 PM',
    rating: 4.6,
    contact: {
      phone: '+54 387 111-2222',
      email: 'info@bellezadelnorte.com.ar',
      whatsapp: 'https://wa.me/5493871112222',
      website: 'https://bellezadelnorte.com.ar',
      address: 'España 500, Salta, Salta'
    },
    images: ['https://placehold.co/400x250/F5F5F5/333333?text=Salta+1', 'https://placehold.co/400x250/FFFFFF/333333?text=Salta+2']
  },
  {
    id: 'mar-estetica',
    listingType: 'clinica',
    name: 'Mar del Plata Estética Avanzada',
    isFeatured: false,
    tier: 1,
    description: 'Centro de estética con foco en tratamientos corporales y faciales no invasivos, con promociones especiales y atención profesional.',
    specialties: ['Tratamientos Corporales', 'Limpieza Facial'],
    city: 'Mar del Plata',
    province: 'Buenos Aires',
    experience: '4+ años',
    hours: 'Lun-Vie: 10 AM - 6 PM',
    rating: 4.5,
    contact: {
      phone: '+54 223 333-4444',
      email: 'contacto@marestatica.com',
      whatsapp: 'https://wa.me/5492233334444',
      website: 'https://marestatica.com',
      address: 'Av. Colón 2500, Mar del Plata, Buenos Aires'
    },
    images: ['https://placehold.co/400x250/FFFFFF/333333?text=MdP+1']
  },
  {
    id: 'tucuman-dermabeauty',
    listingType: 'medicina-estetica',
    name: 'Tucumán Dermabeauty',
    isFeatured: true,
    tier: 3,
    description: 'Clínica de vanguardia en dermatología y medicina estética, ofreciendo soluciones integrales para la salud y belleza de la piel.',
    specialties: ['Dermatología Estética', 'Inyectables y Rellenos', 'Tratamientos Anti-Age'],
    city: 'San Miguel de Tucumán',
    province: 'Tucumán',
    experience: '9+ años',
    hours: 'Lun-Vie: 9 AM - 7 PM',
    rating: 4.9,
    contact: {
      phone: '+54 381 222-3333',
      email: 'info@tucumandermabeauty.com',
      whatsapp: 'https://wa.me/5493812223333',
      website: 'https://tucumandermabeauty.com',
      address: 'San Martín 100, San Miguel de Tucumán, Tucumán'
    },
    additionalServices: ['Láser Fraccionado', 'Bioestimulación', 'Toxina Botulínica'],
    calendarLink: 'https://link.vastfunnel.com/widget/booking/ZyffHAxW8JNBgMMUFm4X',
    crmAccess: true,
    socialMediaManagement: true,
    images: ['https://placehold.co/400x250/5E6C84/FFFFFF?text=Tucuman+1', 'https://placehold.co/400x250/B8860B/FFFFFF?text=Tucuman+2', 'https://placehold.co/400x250/F5F5F5/333333?text=Tucuman+3']
  },
  {
    "id": "dermamedic-cordoba",
    "listingType": "medicina-estetica",
    "name": "DermaMedic Centro de Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro especializado en dermatología y estética con tecnología de vanguardia en Nueva Córdoba",
    "specialties": ["Dermatología Estética", "Tratamientos Faciales", "Inyectables y Rellenos"],
    "city": "Córdoba",
    "province": "Córdoba",
    "experience": "8+ años",
    "hours": "Lun-Vie: 9 AM - 7 PM, Sáb: 9 AM - 1 PM",
    "rating": 4.7,
    "contact": {
      "phone": "+54 351 468-1170",
      "email": "info@dermamedic.com.ar",
      "whatsapp": "https://wa.me/5493517049933",
      "website": "https://dermamedic.ar",
      "address": "Chacabuco 843, Nueva Córdoba, Córdoba"
    },
    "additionalServices": ["Plasma Rico en Plaquetas", "Terapia con Láser", "Consultas Dermatológicas"],
    "calendarLink": "https://dermamedic.ar/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=FEQv6RBIojCswAQm2VHH7reZc4j%2Bj%2BaP3K%2FUDQnzgV%2FWSBsjQNq9%2B7F8h2hHIN6EV9plNH94zAWgkkE7TzsKPeSsq3ntWObDqSXDHnJWU%2B6oLwN6Q8Di%2FQ66sn%2BIdX4Jxmpy888jIlPNfAZ3C9zsZui7B6H%2FIOiz7NneLxA%3D&u2=A7drFaU6MhKGAsXb&width=2560",
      "https://placehold.co/400x250/B8860B/FFFFFF?text=SALA+TRATAMIENTOS",
      "https://placehold.co/400x250/F5F5F5/333333?text=RECEPCION"
    ]
  },
  {
    "id": "clinica-tesler-mar-del-plata",
    "listingType": "clinica",
    "name": "Clínica Tesler",
    "isFeatured": false,
    "tier": 3,
    "description": "Clínica líder en medicina estética y cirugía plástica con tecnología Candela y Profhilo",
    "specialties": ["Depilación Láser", "Inyectables y Rellenos", "Dermatología Estética"],
    "city": "Mar del Plata",
    "province": "Buenos Aires",
    "experience": "15+ años",
    "hours": "Lun-Vie: 8 AM - 8 PM, Sáb: 9 AM - 3 PM",
    "rating": 4.9,
    "contact": {
      "phone": "+54 223 491-5000",
      "email": "info@clinicatesler.com",
      "whatsapp": "https://wa.me/5492234915000",
      "website": "https://clinicatesler.com",
      "address": "San Luis 2850, Mar del Plata, Buenos Aires"
    },
    "additionalServices": ["Cirugía Plástica", "VASER Liposelección", "Carbon Peel"],
    "calendarLink": "https://clinicatesler.com/reservas",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=LtVhdPA6koyhk%2BmxQ5j15BSKZgCjcslDdVb%2BCQyDLHcFYCCEUgZ8FdiuN16SCs9DpTduBZDX%2BDy4TARWaTDPk7IbTe5p5TnnkJWO&u2=eU1fkgGbl4jBWDPI&width=2560",
      "https://placehold.co/400x250/B8860B/FFFFFF?text=CONSULTORIOS",
      "https://placehold.co/400x250/F5F5F5/333333?text=EQUIPAMIENTO"
    ]
  },
  {
    "id": "beauty-site-mendoza",
    "listingType": "spa",
    "name": "Beautysite Centro de Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Spa boutique en Chacras de Coria con tratamientos personalizados y ambiente relajante",
    "specialties": ["Tratamientos Faciales", "Tratamientos Corporales", "Masajes Terapéuticos"],
    "city": "Mendoza",
    "province": "Mendoza",
    "experience": "6+ años",
    "hours": "Mar-Sáb: 10 AM - 7 PM",
    "rating": 4.8,
    "contact": {
      "phone": "+54 261 534-6616",
      "email": "info@beautysite.com.ar",
      "whatsapp": "https://wa.me/542615346616",
      "website": "https://beautysite.com.ar",
      "address": "Pueyrredon 2127, Chacras de Coria, Luján de Cuyo, Mendoza"
    },
    "additionalServices": ["Rituales de Aromaterapia", "Masajes con Piedras Calientes", "Tratamientos Antiage"],
    "calendarLink": "https://beautysite.com.ar/reservas",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=MOkjoQvPWa6Pm%2BRI1eznI9jleCCicB0xzHaEJLjBP2eAvYn0CSLgv8Fu5WBR0eiNyVxoKVfQTNFrPnihmiSp82H5%2BWmOsOvl5F98USyODqX6y79J64Zn5zdCkRKaN6s4Mrk%3D&u2=Cmu0tR4i1N9pvf6b&width=2560",
      "https://placehold.co/400x250/B8860B/FFFFFF?text=SALA+MASAJES",
      "https://placehold.co/400x250/F5F5F5/333333?text=RECEPCION+SPA"
    ]
  },
  {
    "id": "korper-clinica-cordoba",
    "listingType": "clinica",
    "name": "Korper Clínica Privada",
    "isFeatured": false,
    "tier": 2,
    "description": "Clínica privada especializada en medicina estética con excelente reputación en Córdoba",
    "specialties": ["Inyectables y Rellenos", "Tratamientos Faciales"],
    "city": "Córdoba",
    "province": "Córdoba",
    "experience": "5+ años",
    "hours": "Lun-Vie: 9 AM - 6 PM",
    "rating": 4.98,
    "contact": {
      "phone": "+54 351 423-9000",
      "email": "info@korperclinica.com.ar",
      "whatsapp": "https://wa.me/5493514239000",
      "website": "https://korperclinica.com.ar",
      "address": "Obispo Trejo 954, Córdoba"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=IhNfljAmpcErJeqvwEscyaKNEvi4U%2F%2FqTYh1VfYgRIjL%2Br6GHZfhy0TRQZzHYBaOjPzSgK8%2BqAKofYj7Yj1gUeR%2BWAxxRH7ykTptAW4i3xZcsW%2Fp4BObdaNNkDU%2Bzd%2BK6K%2B6&u2=5FOjUv3gc8BS1iNd&width=2560",
      "https://sspark.genspark.ai/cfimages?u1=dawuxTaNMeW2ICidNOFShC2HecKQ%2FGbGAbMBcMsqZxibXjuxl%2B3rjyovBJltkf9WLo9WDwEbUSEdzjjVUqqiSgsKj%2Bcpkox5cL1AsnJL9%2Fw5l5RrIjx2CVA6RETvUr14ZFf5CdMsxCiQPbVo%2Bqti%2BDXE3UoS5VKL7KovIm6eAC7RKphBqbYkRc0T17Jeh1mP6g%3D%3D&u2=YPUfm8Q9KnuYYrBB&width=2560"
    ]
  },
  {
    "id": "adara-centro-cordoba",
    "listingType": "medicina-estetica",
    "name": "Adara Centro Profesional",
    "isFeatured": true,
    "tier": 2,
    "description": "Centro profesional de estética médica y flebología con tecnología avanzada",
    "specialties": ["Dermatología Estética", "Tratamientos Corporales"],
    "city": "Córdoba",
    "province": "Córdoba",
    "experience": "7+ años",
    "hours": "Lun-Vie: 8 AM - 7 PM, Sáb: 9 AM - 2 PM",
    "rating": 4.6,
    "contact": {
      "phone": "+54 810 268-0109",
      "email": "contacto@adaracentro.com.ar",
      "whatsapp": "https://wa.me/5493512006111",
      "website": "https://adaracentroprofesional.com.ar",
      "address": "Av. Colón 579, Córdoba"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=97oFZbTmIH7I%2BCHDXhAFUQ5b0USuazxAV%2B4YXVfs3Q5g7fySx5DOftf%2FV5R03pUq2ktsaa9Jh79gycUpof6yjQQKrf6ubRtwGeqFFCpVYojc7t3ZD7DFaY%2FZ1Vn6tg97%2FYwFBC%2F2Tz%2FsO7uu95X1ftIf2FufjwmshBgL3vnAD12bg5AUHwkaUys1hiX2Y7A8VJI2yRbgmYloAJ35xw4yuNq8NlhKkdl5D5byZfOb%2BSVaXUax&u2=A5yJ3zWFL%2F2a6J4S&width=2560",
      "https://placehold.co/400x250/FFFFFF/333333?text=SALA+MEDICINA"
    ]
  },
  {
    "id": "awa-spa-tucuman",
    "listingType": "spa",
    "name": "AWA Spa Estética Integral",
    "isFeatured": false,
    "tier": 2,
    "description": "Spa integral para hombres y mujeres enfocado en salud, belleza y bienestar",
    "specialties": ["Masajes Terapéuticos", "Tratamientos Faciales", "Tratamientos Corporales"],
    "city": "San Miguel de Tucumán",
    "province": "Tucumán",
    "experience": "4+ años",
    "hours": "Lun-Sáb: 9 AM - 8 PM",
    "rating": 4.5,
    "contact": {
      "phone": "+54 381 425-7800",
      "email": "info@awaspa.com.ar",
      "whatsapp": "https://wa.me/5493814257800",
      "website": "https://awaspa.com.ar",
      "address": "25 de Mayo 710, San Miguel de Tucumán"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=F18aHpjXLFBHlKVGTohE7JdkmNPhTvSLxSiU%2BBqptA81WxuoiMDP7xK51sgYzQSFL6AH5qGRIkMoq0C8Wmuvk59QtuYUn1d%2B8O8tfZB0RrP9yJDfKPc%3D&u2=MjlQg1mtJyIrLbca&width=2560",
      "https://placehold.co/400x250/FFFFFF/333333?text=SALA+SPA"
    ]
  },
  {
    "id": "clinica-delucca-santa-fe",
    "listingType": "clinica",
    "name": "Clínica De Lucca Dermatología",
    "isFeatured": true,
    "tier": 2,
    "description": "Clínica especializada en dermatología estética con más de 10 años de experiencia",
    "specialties": ["Dermatología Estética", "Tratamientos Faciales"],
    "city": "Santa Fe",
    "province": "Santa Fe",
    "experience": "12+ años",
    "hours": "Lun-Vie: 9 AM - 6 PM",
    "rating": 4.7,
    "contact": {
      "phone": "+54 342 590-9026",
      "email": "deluccaclinica@gmail.com",
      "whatsapp": "https://wa.me/5493425909026",
      "website": "https://clinicadelucca.com",
      "address": "Sarmiento 3631, Santa Fe"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=lHzWfp1RPUkRVQKAkiqh%2F2oPshMi5Qck6zhG9juNnXdNL9zQjVnwws10U9lf7uAaoZeoEI%2FWfCH4KpnuQbOtHELF9qz3wKwREt3m8NOF%2F522bB7cp%2BEh3KKRaSvj2kdmZqRmM%2BGNMhFbv54yOAqrnBGCO%2BM62Vl%2FWNRA0uiZuMzOPyVp0UAIzljT7%2BbQX9eU6MDDQYvLJkiL0v2Y8CRGMdmKH%2FsCWB1XyMVjgOQ%3D%3D&u2=ba0wLMarlB8ItM4r&width=2560",
      "https://placehold.co/400x250/FFFFFF/333333?text=CONSULTORIO+DERMA"
    ]
  },
  {
    "id": "bio-estetica-san-juan",
    "listingType": "spa",
    "name": "BIO Estética y Spa",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro integral de belleza especializado en manicuría, pedicuría y tratamientos spa",
    "specialties": ["Manicuría y Pedicuría", "Estética de Pestañas y Cejas"],
    "city": "San Juan",
    "province": "San Juan",
    "experience": "3+ años",
    "hours": "Lun-Sáb: 9 AM - 7 PM",
    "rating": 4.3,
    "contact": {
      "phone": "+54 264 422-5500",
      "email": "info@bioesteticaspa.com.ar",
      "whatsapp": "https://wa.me/5492644225500",
      "website": "https://bioesteticaspa.com.ar",
      "address": "San Martín 1250, San Juan"
    },
    "images": [
      "https://placehold.co/400x250/F5F5F5/333333?text=BIO+ESTETICA"
    ]
  },
  {
    "id": "beauty-co-la-plata",
    "listingType": "salon",
    "name": "Beauty Co. Centro de Belleza",
    "isFeatured": true,
    "tier": 1,
    "description": "Centro de belleza completo especializado en manos, pies, cejas y maquillaje",
    "specialties": ["Manicuría y Pedicuría", "Estética de Pestañas y Cejas"],
    "city": "La Plata",
    "province": "Buenos Aires",
    "experience": "4+ años",
    "hours": "Mar-Sáb: 10 AM - 7 PM",
    "rating": 4.4,
    "contact": {
      "phone": "+54 221 364-6694",
      "email": "contacto@beautyco.com.ar",
      "whatsapp": "https://wa.me/5492213646694",
      "website": "https://beautyco.com.ar",
      "address": "Calle 7 N° 850, La Plata, Buenos Aires"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=gKxqhCHYTjW9YGiIiEhdNm0EeIc0r068EnDke0FVni7tz9d0oy%2Fos1327ssmpuRiYS1B%2BydR77Woqkf77046HvfQu%2BqPuBUgAgrK5yx7PV48COAif5xrWOnJbyY91b5oLJ1EmtlkUJhwTauMEJbK2mRosOURdWQB3CWQ2IFnel%2FswohT&u2=zYNmtMLmQhqFyyq%2B&width=2560"
    ]
  },
  {
    "id": "luxury-salon-rosario",
    "listingType": "salon",
    "name": "Luxury Salón de Belleza Boutique",
    "isFeatured": false,
    "tier": 1,
    "description": "Salón boutique especializado en peluquería y estilismo profesional",
    "specialties": ["Tratamientos Faciales", "Estética de Pestañas y Cejas"],
    "city": "Rosario",
    "province": "Santa Fe",
    "experience": "6+ años",
    "hours": "Lun-Sáb: 8:30 AM - 7 PM",
    "rating": 4.2,
    "contact": {
      "phone": "+54 341 302-4062",
      "email": "info@luxurysalon.com.ar",
      "whatsapp": "https://wa.me/5493413024062",
      "website": "https://luxurysalon.com.ar",
      "address": "Sarmiento 887, Rosario, Santa Fe"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=2Pg7rq0iFQkywvhTUIhYWqxIRYk9%2FqMKD4pF%2BBNUvIrogoBhatBsG1owSVChcZ7oo70ZuDpmmZrFTJK2vEbMZzkH19yI2OqN3WhK8WlHAI3Qgw4s3LxwhauXD%2BRvS%2BSZoQgSCoawBsAbV3s%3D&u2=ZeUgexGlY1T%2FCueN&width=2560"
    ]
  },
  {
    "id": "vz-espacio-salta",
    "listingType": "spa",
    "name": "VZ Espacio Estética & Spa",
    "isFeatured": true,
    "tier": 1,
    "description": "Espacio de estética y spa con dos sucursales en Salta capital",
    "specialties": ["Tratamientos Faciales", "Masajes Terapéuticos"],
    "city": "Salta",
    "province": "Salta",
    "experience": "5+ años",
    "hours": "Lun-Vie: 9 AM - 7 PM, Sáb: 9 AM - 4 PM",
    "rating": 4.6,
    "contact": {
      "phone": "+54 387 455-9364",
      "email": "info@vzespacioestetica.com.ar",
      "whatsapp": "https://wa.me/5493874559364",
      "website": "https://vzespacioestetica.com.ar",
      "address": "Pasaje Klein 50, Salta"
    },
    "images": [
      "https://placehold.co/400x250/F5F5F5/333333?text=VZ+ESPACIO"
    ]
  },
  {
    "id": "estetica-plenitud-resistencia",
    "listingType": "salon",
    "name": "Estética Plenitud",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro de estética integral enfocado en tratamientos personalizados",
    "specialties": ["Tratamientos Faciales", "Depilación Láser"],
    "city": "Resistencia",
    "province": "Chaco",
    "experience": "4+ años",
    "hours": "Lun-Vie: 9 AM - 7 PM, Sáb: 9 AM - 1 PM",
    "rating": 4.1,
    "contact": {
      "phone": "+54 362 444-5200",
      "email": "info@esteticaplenitud.com.ar",
      "whatsapp": "https://wa.me/5493624445200",
      "website": "https://esteticaplenitud.com.ar",
      "address": "Av. Alberdi 1200, Resistencia, Chaco"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=tOk022RMXISHo0NZwycwufdP2%2B820PAK4db4iEL7dEufVtvpxxGvS5uBvjJcOwA%2BbUbnay3ax7M2iBlGPuvtneNoGVDOMpOxaxIYLQ%3D%3D&u2=vX0qnFd22zgTZKTb&width=2560"
    ]
  },
  {
    "id": "marilia-almeida-beauty-center",
    "listingType": "spa",
    "name": "Marilia Almeida Beauty Center",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro de belleza premium especializado en tratamientos faciales avanzados y cuidado integral",
    "specialties": ["Tratamientos Faciales", "Dermatología Estética", "Masajes Terapéuticos"],
    "city": "La Rioja Capital",
    "province": "La Rioja",
    "experience": "10+ años",
    "hours": "Lun-Vie: 9 AM - 8 PM, Sáb: 9 AM - 5 PM",
    "rating": 4.9,
    "contact": {
      "phone": "+54 380 442-8500",
      "email": "info@mariliaalmeida.com.ar",
      "whatsapp": "https://wa.me/5493804428500",
      "website": "https://marilia-almeida-belleza-natural.lovable.app/",
      "address": "San Martín 450, La Rioja Capital, La Rioja"
    },
    "additionalServices": ["Armonización Facial", "Tratamientos Anti-edad", "Consultas Personalizadas"],
    "calendarLink": "https://link.vastfunnel.com/widget/booking/DEOtRAujQnVucSR6qhZx",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/5E6C84/FFFFFF?text=MARILIA+ALMEIDA",
      "https://placehold.co/400x250/B8860B/FFFFFF?text=SALA+TRATAMIENTOS",
      "https://placehold.co/400x250/F5F5F5/333333?text=RECEPCION+PREMIUM"
    ]
  },
  {
    "id": "acqua-centro-la-rioja",
    "listingType": "spa",
    "name": "Acqua Centro de Estética",
    "isFeatured": false,
    "tier": 3,
    "description": "Centro integral de estética y bienestar con servicios personalizados en La Rioja capital",
    "specialties": ["Tratamientos Corporales", "Masajes Terapéuticos", "Tratamientos Faciales"],
    "city": "La Rioja Capital",
    "province": "La Rioja",
    "experience": "7+ años",
    "hours": "Lun-Vie: 9 AM - 7 PM, Sáb: 9 AM - 2 PM",
    "rating": 4.6,
    "contact": {
      "phone": "+54 380 411-9471",
      "email": "info@acquaestetica.com.ar",
      "whatsapp": "https://wa.me/5493804258049",
      "website": "https://acquaestetica.com.ar",
      "address": "Benjamín de la Vega 214, La Rioja Capital"
    },
    "additionalServices": ["Hidroterapia", "Drenaje Linfático", "Tratamientos Reductores"],
    "calendarLink": "https://acquaestetica.com.ar/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=R5czqIiVQFIgg7vg6tK2hDt5Eis%2B%2BocXwm0D7r3qYuNbFLl2oOmsjsb35vwEveY%2Fzb0PoPQ5CXvkV5RCaK5t5cyqwl%2FHO9mD98ABicEIqSCT28NPpA%2B9CwD26m8vgS89&u2=PNPVPfE1wyFv8N52&width=2560",
      "https://placehold.co/400x250/B8860B/FFFFFF?text=SALA+HIDRO",
      "https://placehold.co/400x250/F5F5F5/333333?text=AREA+RELAX"
    ]
  },
  {
    "id": "fleurs-estetica-la-rioja",
    "listingType": "spa",
    "name": "Fleurs Estética & Spa",
    "isFeatured": false,
    "tier": 2,
    "description": "Centro especializado en depilación láser y tratamientos corporales en zona sur de La Rioja",
    "specialties": ["Depilación Láser", "Masajes Terapéuticos", "Tratamientos Corporales"],
    "city": "La Rioja",
    "province": "La Rioja",
    "experience": "5+ años",
    "hours": "Lun-Sáb: 9 AM - 7 PM",
    "rating": 4.4,
    "contact": {
      "phone": "+54 380 444-7263",
      "email": "info@fleursestetica.com.ar",
      "whatsapp": "https://wa.me/5493804447263",
      "website": "https://fleursestetica.com.ar",
      "address": "Arrayanes esquina Chingaza, Barrio Seipos 2, La Rioja"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=QpRC0JY2dCLcRc0gw2G%2FKykez9RLMT2FTOs%2F8JuPznMslr6rAJL28DGyEw6EKKEQ1gaftZBSBvZmaBmLEgKHv2h5LgxEf%2BZJPhbBKn7k8f1y6RnMHagQrf2RJvcfb7t3Om7SnDu4FXo4lg%3D%3D&u2=XTbOguMXPpl4UiNm&width=2560",
      "https://placehold.co/400x250/FFFFFF/333333?text=SALA+DEPILACION"
    ]
  },
  {
    "id": "reina-mora-spa-chilecito",
    "listingType": "spa",
    "name": "Reina Mora Spa",
    "isFeatured": true,
    "tier": 2,
    "description": "Spa de belleza integral en Chilecito con servicios unisex y tratamientos completos",
    "specialties": ["Depilación Láser", "Manicuría y Pedicuría", "Tratamientos Faciales"],
    "city": "Chilecito",
    "province": "La Rioja",
    "experience": "6+ años",
    "hours": "Mar-Sáb: 9 AM - 7 PM",
    "rating": 4.3,
    "contact": {
      "phone": "+54 380 342-6500",
      "email": "info@reinamoraspa.com.ar",
      "whatsapp": "https://wa.me/5493803426500",
      "website": "https://reinamoraspa.com.ar",
      "address": "Av. Pelagio Luna 890, Chilecito, La Rioja"
    },
    "images": [
      "https://sspark.genspark.ai/cfimages?u1=yWOl8wSfJwOqh1OstukiIqVs9kqIDKl3BWqkjvRehOsRBL4ZEVjqqYuATKGrxlSGqh9g4aZL9clfI1NczEo%2B6cI49hkALoAdQvmovMVSbldrtBZ90yI7rCr39eanHG%2FJOROzjN%2FhVarffg%3D%3D&u2=fFX4lDzu%2FUrmOGYe&width=2560",
      "https://placehold.co/400x250/FFFFFF/333333?text=SALA+UNISEX"
    ]
  },
  {
    "id": "pai-pai-beauty-la-rioja",
    "listingType": "salon",
    "name": "Pai Pai Beauty Studio",
    "isFeatured": false,
    "tier": 1,
    "description": "Estudio de belleza especializado en uñas y cuidado personal integral",
    "specialties": ["Manicuría y Pedicuría", "Tratamientos Faciales"],
    "city": "La Rioja Capital",
    "province": "La Rioja",
    "experience": "3+ años",
    "hours": "Lun-Sáb: 9 AM - 6 PM",
    "rating": 4.2,
    "contact": {
      "phone": "+54 380 415-6789",
      "email": "info@paipaibeauty.com.ar",
      "whatsapp": "https://wa.me/5493804156789",
      "website": "https://paipaibeauty.com.ar",
      "address": "Belgrano 373, La Rioja Capital"
    },
    "images": [
      "https://lh3.googleusercontent.com/p/AF1QipPFW2aMMgZk0mGRubwDjN1tELNES7Anm4gsK5__=w1600-h1200",
      "https://lh3.googleusercontent.com/p/AF1QipMgmudyLKx4VVQEWBZhiSkFaG0Nk_FnvNQpmflc=w1600-h1200"
    ]
  },
  {
    "id": "fairys-medicina-estetica-la-rioja",
    "listingType": "medicina-estetica",
    "name": "Fairys Medicina Estética Biológica",
    "isFeatured": true,
    "tier": 1,
    "description": "Centro de medicina estética con enfoque en tratamientos biológicos naturales",
    "specialties": ["Dermatología Estética", "Inyectables y Rellenos"],
    "city": "La Rioja Capital",
    "province": "La Rioja",
    "experience": "8+ años",
    "hours": "Lun-Vie: 8 AM - 6 PM",
    "rating": 4.5,
    "contact": {
      "phone": "+54 380 423-7890",
      "email": "info@fairysestetica.com.ar",
      "whatsapp": "https://wa.me/5493804237890",
      "website": "https://fairysestetica.com.ar",
      "address": "Samuel Luna 150, La Rioja Capital"
    },
    "images": [
      "https://lh3.googleusercontent.com/p/AF1QipMZoi-X-Z2K1H8xbvokrvMsRWy0ruPKQm6-I_Uj=w1600-h1200",
      "https://lh3.googleusercontent.com/p/AF1QipPYNowEx2ipymmReW3TEBRHpjH6eRn3r0Yy-UKF=w1600-h1200"
    ]
  },
  {
    "id": "avec-belle-rio-grande-tdf",
    "listingType": "medicina-estetica",
    "name": "Avec Belle Médicina Estética y Láser",
    "isFeatured": true,
    "tier": 3,
    "description": "Clínica de medicina estética con tecnología láser avanzada y más de 10,000 tratamientos realizados. Directora médica especializada.",
    "specialties": [
      "Depilación Láser",
      "Toxina Botulínica",
      "Inyectables y Rellenos",
      "Rejuvenecimiento facial",
      "Tratamientos Corporales"
    ],
    "city": "Río Grande",
    "province": "Tierra del Fuego",
    "experience": "7+ años",
    "hours": "Lunes a Viernes 09:00-20:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 2964 15-234567",
      "email": "info@avecbelle.com.ar",
      "whatsapp": "https://wa.me/5492964234567",
      "website": "https://avecbellemedicinaestetica.com/"
    },
    "address": "Barrio Mutual, Río Grande, Tierra del Fuego, Argentina",
    "additionalServices": [
      "Borrado de Tatuajes",
      "Eliminación de Cicatrices",
      "Rinomodelación",
      "Tratamientos con tecnología ANMAT"
    ],
    "calendarLink": "https://calendly.com/avecbelle",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/4A90E2/FFFFFF?text=Avec+Belle+Medicina+Estetica",
      "https://placehold.co/400x250/7ED321/FFFFFF?text=Tecnologia+Laser+Avanzada",
      "https://placehold.co/400x250/BD10E0/FFFFFF?text=Consultorio+Moderno"
    ]
  },
  {
    "id": "paradisea-spa-ushuaia-tdf",
    "listingType": "spa",
    "name": "Paradisea Spa Holístico Urbano",
    "isFeatured": true,
    "tier": 2,
    "description": "Primer spa holístico de Tierra del Fuego con más de 30 años de trayectoria. Tratamientos corporales, faciales y holísticos especializados.",
    "specialties": [
      "Tratamientos Faciales",
      "Tratamientos Corporales",
      "Bienestar",
      "Hidroterapia",
      "Masajes Terapéuticos"
    ],
    "city": "Ushuaia",
    "province": "Tierra del Fuego",
    "experience": "30+ años",
    "hours": "Lunes a Sábado 09:00-20:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 2901 15-432109",
      "email": "info@ushuaiaspa.com",
      "whatsapp": "https://wa.me/5492901432109",
      "website": "https://ushuaiaspa.com/"
    },
    "address": "Ushuaia, Tierra del Fuego, Argentina",
    "images": [
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=Paradisea+Spa+Holistico",
      "https://placehold.co/400x250/F5A623/FFFFFF?text=Tratamientos+Corporales",
      "https://placehold.co/400x250/9013FE/FFFFFF?text=Ambiente+Relajante"
    ]
  },
  {
    "id": "barsa-beauty-bar-tdf",
    "listingType": "salon",
    "name": "BARSA Beauty Bar",
    "isFeatured": false,
    "tier": 1,
    "description": "Salón de belleza integral con servicios de estética, peluquería y venta de productos cosméticos. Atención personalizada y profesional.",
    "specialties": [
      "Cortes y Peinados",
      "Manicuría y Pedicuría",
      "Estética de Pestañas y Cejas",
      "Tratamientos Faciales"
    ],
    "city": "Río Grande",
    "province": "Tierra del Fuego",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 10:00-20:00, Sábados 10:00-18:00",
    "rating": 4.9,
    "contact": {
      "phone": "+54 2964 601600",
      "email": "info@barsabeauty.com.ar",
      "whatsapp": "https://wa.me/5492964601600",
      "website": "https://barsa.agendapro.com/ar"
    },
    "address": "Avenida Manuel Belgrano 1970, Río Grande, Tierra del Fuego",
    "images": [
      "https://placehold.co/400x250/D0021B/FFFFFF?text=BARSA+Beauty+Bar",
      "https://placehold.co/400x250/417505/FFFFFF?text=Salon+Moderno"
    ]
  },
  {
    "id": "cikru-estetica-ushuaia-tdf",
    "listingType": "medicina-estetica",
    "name": "Cikru Medicina Estética y Bienestar",
    "isFeatured": false,
    "tier": 2,
    "description": "Centro de medicina estética con enfoque en belleza y bienestar integrados. Tratamientos seguros y efectivos en el fin del mundo.",
    "specialties": [
      "Medicina Estética",
      "Bienestar",
      "Tratamientos Anti-Age",
      "Consultas Personalizadas"
    ],
    "city": "Ushuaia",
    "province": "Tierra del Fuego",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 09:00-19:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 2901 506187",
      "email": "turnos@cikru.com.ar",
      "whatsapp": "https://wa.me/5492901506187",
      "website": "https://cikru.com.ar"
    },
    "address": "Rio Iguazu 738, Ushuaia, Tierra del Fuego 9410",
    "images": [
      "https://placehold.co/400x250/B8E986/FFFFFF?text=Cikru+Medicina+Estetica",
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=Bienestar+Integrado"
    ]
  },
  {
    "id": "medicina-estetica-varela-sc",
    "listingType": "medicina-estetica",
    "name": "Medicina Estética Dr. Ariel Varela",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro de medicina estética reparadora dirigido por el Dr. Ariel Varela. Tratamientos médicos especializados en Río Gallegos.",
    "specialties": [
      "Medicina Estética",
      "Cirugía Plástica",
      "Tratamientos Anti-Age",
      "Dermatología Estética",
      "Consultas Personalizadas"
    ],
    "city": "Río Gallegos",
    "province": "Santa Cruz",
    "experience": "12+ años",
    "hours": "Lunes a Viernes 09:00-21:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 2966 15-222222",
      "email": "consultas@drvarela.com.ar",
      "whatsapp": "https://wa.me/5492966222222",
      "website": "https://medicinaesteticavarela.com.ar"
    },
    "address": "Belgrano 173, Río Gallegos, Santa Cruz",
    "additionalServices": [
      "Cirugía Estética",
      "Medicina Reparadora",
      "Tratamientos Láser",
      "Consultas Especializadas"
    ],
    "calendarLink": "https://turnos.drvarela.com.ar",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/4A90E2/FFFFFF?text=Dr+Ariel+Varela",
      "https://placehold.co/400x250/BD10E0/FFFFFF?text=Medicina+Estetica",
      "https://placehold.co/400x250/7ED321/FFFFFF?text=Consultorio+Profesional"
    ]
  },
  {
    "id": "dra-ligorria-rio-gallegos-sc",
    "listingType": "medicina-estetica",
    "name": "Dra. Ligorria Medicina & Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Más de 16 años de trayectoria en medicina estética. Especialista en tratamientos faciales y corporales con técnicas avanzadas.",
    "specialties": [
      "Medicina Estética",
      "Inyectables y Rellenos",
      "Toxina Botulínica",
      "Tratamientos Faciales",
      "Armonización Facial"
    ],
    "city": "Río Gallegos",
    "province": "Santa Cruz",
    "experience": "16+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 2966 438622",
      "email": "turnos@draligorria.com.ar",
      "whatsapp": "https://wa.me/5492966438622",
      "website": "https://draligorria.com.ar"
    },
    "address": "Neuquén 186, Río Gallegos, Santa Cruz",
    "images": [
      "https://placehold.co/400x250/F5A623/FFFFFF?text=Dra+Ligorria",
      "https://placehold.co/400x250/D0021B/FFFFFF?text=16+Años+Experiencia"
    ]
  },
  {
    "id": "centro-estetica-medicina-sc",
    "listingType": "clinica",
    "name": "Centro de Estética Medicina Estética",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro integral de medicina estética ubicado en el corazón de Río Gallegos. Tratamientos personalizados y tecnología moderna.",
    "specialties": [
      "Medicina Estética",
      "Tratamientos Faciales",
      "Depilación Láser",
      "Radiofrecuencia"
    ],
    "city": "Río Gallegos",
    "province": "Santa Cruz",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 09:00-19:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 2966 422734",
      "email": "info@centroesteticarg.com.ar",
      "whatsapp": "https://wa.me/5492966422734",
      "website": "https://centroesteticarg.com.ar"
    },
    "address": "Av. José de San Martín 1688, Río Gallegos, Santa Cruz",
    "images": [
      "https://placehold.co/400x250/9013FE/FFFFFF?text=Centro+Estetica+RG",
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=Tecnologia+Moderna"
    ]
  },
  {
    "id": "kr-estetica-corrientes",
    "listingType": "clinica",
    "name": "KR Estética",
    "isFeatured": true,
    "tier": 2,
    "description": "Centro de estética avanzada con tecnología de radiofrecuencia y tratamientos faciales especializados. Atención personalizada y resultados efectivos.",
    "specialties": [
      "Radiofrecuencia",
      "Tratamientos Faciales",
      "Plasma Rico en Plaquetas",
      "Peelings Químicos",
      "Tratamientos Anti-Age"
    ],
    "city": "Corrientes",
    "province": "Corrientes",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 08:00-20:00, Sábados 09:00-16:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 379 4883105",
      "email": "turnos@krestetica.com.ar",
      "whatsapp": "https://wa.me/5493794883105",
      "website": "https://krestetica.agendapro.com"
    },
    "address": "Hipólito Yrigoyen 1484, Corrientes, Corrientes",
    "images": [
      "https://lh3.googleusercontent.com/p/AF1QipM4oUpY4cs7MrQprEXbSM0ZeqiNNtB-qWiQsLdi=w1600-h1200",
      "https://lh3.googleusercontent.com/p/AF1QipM6DjFnvQ1gUjXUfHpbDuqMZzi9PoPXexoel0BG=w1600-h1200"
    ]
  },
  {
    "id": "dra-hebe-blanco-corrientes",
    "listingType": "medicina-estetica",
    "name": "Dra. Hebe Blanco Cirugía Plástica y Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Especialista en cirugía plástica y medicina estética. Tratamientos combinados con resultados sutiles y efecto visible. Consultas personalizadas.",
    "specialties": [
      "Cirugía Plástica",
      "Medicina Estética",
      "Toxina Botulínica",
      "Inyectables y Rellenos",
      "Armonización Facial"
    ],
    "city": "Corrientes",
    "province": "Corrientes",
    "experience": "15+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.9,
    "contact": {
      "phone": "+54 379 4019266",
      "email": "consultas@drahebeblanco.com.ar",
      "whatsapp": "https://wa.me/5493794019266",
      "website": "https://drahebeblanco.com.ar"
    },
    "address": "Corrientes Capital, Corrientes",
    "additionalServices": [
      "Cirugía Estética",
      "Tratamientos Combinados",
      "Consultas Especializadas",
      "Seguimiento Post-Tratamiento"
    ],
    "calendarLink": "https://turnos.drahebeblanco.com.ar",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/BD10E0/FFFFFF?text=Dra+Hebe+Blanco",
      "https://placehold.co/400x250/F5A623/FFFFFF?text=Cirugia+Plastica",
      "https://placehold.co/400x250/D0021B/FFFFFF?text=15+Años+Experiencia"
    ]
  },
  {
    "id": "centro-estetica-hanna-corrientes",
    "listingType": "salon",
    "name": "Centro de Estética Hanna",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro de estética integral ubicado en barrio La Cruz. Tratamientos faciales y corporales con atención personalizada y ambiente cálido.",
    "specialties": [
      "Tratamientos Faciales",
      "Limpieza Facial",
      "Tratamientos Corporales",
      "Masajes Terapéuticos"
    ],
    "city": "Corrientes",
    "province": "Corrientes",
    "experience": "7+ años",
    "hours": "Lunes a Sábado 09:00-19:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 379 4073863",
      "email": "centrohanna@gmail.com",
      "whatsapp": "https://wa.me/5493794073863",
      "website": "https://centroesteticahanna.com.ar"
    },
    "address": "Belgrano 759, Barrio La Cruz, Corrientes Capital",
    "images": [
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=Centro+Estetica+Hanna",
      "https://placehold.co/400x250/9013FE/FFFFFF?text=Ambiente+Calido"
    ]
  },
  {
    "id": "dra-florencia-sartori-misiones",
    "listingType": "medicina-estetica",
    "name": "Dra. Florencia Sartori Medicina Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro de medicina estética con consultorio moderno y vistas espectaculares. Especialista en tratamientos faciales y corporales avanzados.",
    "specialties": [
      "Medicina Estética",
      "Tratamientos Faciales",
      "Inyectables y Rellenos",
      "Bioestimulación",
      "Consultas Personalizadas"
    ],
    "city": "Posadas",
    "province": "Misiones",
    "experience": "12+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 376 4583564",
      "email": "turnos@draflorenciasartori.com.ar",
      "whatsapp": "https://wa.me/5493764583564",
      "website": "https://draflorenciasartori.com.ar"
    },
    "address": "Av. Antártida Argentina 876, Oficina 302, Posadas, Misiones",
    "additionalServices": [
      "Consultoría Estética",
      "Tratamientos Personalizados",
      "Seguimiento Integral",
      "Medicina Preventiva"
    ],
    "calendarLink": "https://calendario.draflorenciasartori.com.ar",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/4A90E2/FFFFFF?text=Dra+Florencia+Sartori",
      "https://placehold.co/400x250/7ED321/FFFFFF?text=Consultorio+Moderno",
      "https://placehold.co/400x250/BD10E0/FFFFFF?text=Medicina+Estetica"
    ]
  },
  {
    "id": "elenice-estetica-avanzada-misiones",
    "listingType": "clinica",
    "name": "ELENICE - Estética Avanzada",
    "isFeatured": false,
    "tier": 2,
    "description": "Especialistas en el cuidado de la piel con tratamientos avanzados. Consultas profesionales y tecnología de vanguardia en el corazón de Posadas.",
    "specialties": [
      "Dermatología Estética",
      "Tratamientos Faciales",
      "Fisioterapia",
      "Cuidado de la Piel",
      "Consultas Personalizadas"
    ],
    "city": "Posadas",
    "province": "Misiones",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 08:00-19:00, Sábados 09:00-15:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 376 5075393",
      "email": "turnos@elenice.com.ar",
      "whatsapp": "https://wa.me/5493765075393",
      "website": "https://elenice.com.ar"
    },
    "address": "La Rioja 2239, Local 1, Posadas, Misiones",
    "images": [
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=ELENICE+Estetica",
      "https://placehold.co/400x250/F5A623/FFFFFF?text=Cuidado+Profesional"
    ]
  },
  {
    "id": "olivier-centro-laser-misiones",
    "listingType": "clinica",
    "name": "Olivier - Centro de Estética y Laser",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro especializado en tratamientos láser y estética. Servicios en Posadas y Oberá con tecnología avanzada para resultados efectivos.",
    "specialties": [
      "Depilación Láser",
      "Terapia con Láser",
      "Tratamientos Faciales",
      "Rejuvenecimiento facial"
    ],
    "city": "Posadas",
    "province": "Misiones",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 376 4435260",
      "email": "consultas@olivier.com.ar",
      "whatsapp": "https://wa.me/5493764435260",
      "website": "https://olivier.com.ar"
    },
    "address": "Sarmiento 1756, 1er piso, Posadas, Misiones",
    "images": [
      "https://placehold.co/400x250/D0021B/FFFFFF?text=Olivier+Centro+Laser",
      "https://placehold.co/400x250/9013FE/FFFFFF?text=Tecnologia+Laser"
    ]
  },
  {
    "id": "mantra-centro-estetica-neuquen",
    "listingType": "spa",
    "name": "Mantra Centro de Estética",
    "isFeatured": true,
    "tier": 2,
    "description": "Tratamientos pensados para cada cuerpo y hábitos individuales. Centro especializado en depilación láser y cuidado corporal integral.",
    "specialties": [
      "Depilación Láser",
      "Tratamientos Corporales",
      "Bienestar",
      "Consultas Personalizadas",
      "Cuidado Integral"
    ],
    "city": "Neuquén",
    "province": "Neuquén",
    "experience": "9+ años",
    "hours": "Lunes a Viernes 09:00-20:00, Sábados 09:00-18:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 299 4131015",
      "email": "turnos@mantraestetica.com.ar",
      "whatsapp": "https://wa.me/5492994131015",
      "website": "https://mantraestetica.agendapro.com"
    },
    "address": "Av. Argentina 596, Neuquén, Neuquén",
    "images": [
      "https://placehold.co/400x250/B8E986/FFFFFF?text=Mantra+Centro+Estetica",
      "https://placehold.co/400x250/50E3C2/FFFFFF?text=Tratamientos+Integrales"
    ]
  },
  {
    "id": "jaio-estetica-neuquen",
    "listingType": "salon",
    "name": "Jaio Estética",
    "isFeatured": false,
    "tier": 1,
    "description": "Especialistas en cuidado de manos y uñas. Servicios de manicuría, kapping y belleza con herramientas esterilizadas para máxima seguridad.",
    "specialties": [
      "Manicuría y Pedicuría",
      "Estética de Pestañas y Cejas",
      "Tratamientos de Manos",
      "Cuidado Personal"
    ],
    "city": "Neuquén",
    "province": "Neuquén",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 09:00-19:00, Sábados 09:00-16:00",
    "rating": 4.9,
    "contact": {
      "phone": "+54 299 4567890",
      "email": "turnos@jaioestetica.com.ar",
      "whatsapp": "https://wa.me/5492994567890",
      "website": "https://jaioestetica.agendapro.com"
    },
    "address": "Entre Ríos 510, Neuquén, Neuquén",
    "images": [
      "https://placehold.co/400x250/417505/FFFFFF?text=Jaio+Estetica",
      "https://placehold.co/400x250/F5A623/FFFFFF?text=Cuidado+de+Manos"
    ]
  },
  {
    "id": "mejorarte-medicina-estetica-neuquen",
    "listingType": "medicina-estetica",
    "name": "Mejorarte Medicina Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro médico especializado en botox, ácido hialurónico y tratamientos faciales. Opciones de financiación y tecnología de vanguardia.",
    "specialties": [
      "Toxina Botulínica",
      "Inyectables y Rellenos",
      "Medicina Estética",
      "Tratamientos Anti-Age",
      "Armonización Facial"
    ],
    "city": "Neuquén",
    "province": "Neuquén",
    "experience": "11+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 299 4123456",
      "email": "consultas@mejorarte.com.ar",
      "whatsapp": "https://wa.me/5492994123456",
      "website": "https://mejorarte.agendapro.com"
    },
    "address": "Islas Malvinas 221, Neuquén, Neuquén",
    "additionalServices": [
      "Financiación en 6 cuotas",
      "Tratamientos Combinados",
      "Consultas Especializadas",
      "Seguimiento Personalizado"
    ],
    "calendarLink": "https://turnos.mejorarte.com.ar",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://placehold.co/400x250/BD10E0/FFFFFF?text=Mejorarte+Medicina",
      "https://placehold.co/400x250/4A90E2/FFFFFF?text=Botox+Especializado",
      "https://placehold.co/400x250/7ED321/FFFFFF?text=Financiacion+Disponible"
    ]
  },
  {
    "id": "dyme-dermatologia-bariloche-rn",
    "listingType": "medicina-estetica",
    "name": "DyME - Dermatología y Medicina Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro médico especializado en dermatología y medicina estética en Bariloche. Tratamientos avanzados con tecnología de vanguardia.",
    "specialties": [
      "Dermatología Estética",
      "Medicina Estética",
      "Laser CO2 Fraccionado",
      "Tratamientos Anti-Age",
      "Consultas Personalizadas"
    ],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "15+ años",
    "hours": "Lunes a Viernes 09:00-18:00",
    "rating": 4.9,
    "contact": {
      "phone": "+54 294 4433077",
      "email": "info@dymeargentina.com",
      "whatsapp": "https://wa.me/5492944433077",
      "website": "http://dymeargentina.com"
    },
    "address": "Rolando 430, San Carlos de Bariloche, Río Negro 8400",
    "additionalServices": [
      "Dermatología Clínica",
      "Cirugía Dermatológica",
      "Medicina Preventiva",
      "Diagnóstico Avanzado"
    ],
    "calendarLink": "https://turnos.dymeargentina.com",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://lh3.googleusercontent.com/p/AF1QipNWk3xaLPO-UL84cTNFOp2VorFFYxjuLvLWNE-N=w1600-h1200",
      "https://lh3.googleusercontent.com/p/AF1QipO7jGTepPO8B2eX0BHmqkhlMUn5OSTQdOrik24L=w1600-h1200"
    ]
  },
  {
    "id": "spa-del-sur-bariloche-rn",
    "listingType": "spa",
    "name": "Spa del Sur",
    "isFeatured": false,
    "tier": 2,
    "description": "Un oasis de relajación en Bariloche con tratamientos de spa y masajes terapéuticos para el bienestar total.",
    "specialties": [
      "Masajes Terapéuticos",
      "Bienestar",
      "Circuitos Hídricos",
      "Rituales de Aromaterapia"
    ],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "8+ años",
    "hours": "Martes a Sábado 10:00-20:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 294 4421234",
      "email": "info@spadelsurbariloche.com.ar",
      "whatsapp": "https://wa.me/5492944421234",
      "website": "https://spadelsurbariloche.com.ar"
    },
    "address": "Av. Bustillo Km 5, San Carlos de Bariloche, Río Negro",
    "images": [
      "https://lh3.googleusercontent.com/gps-cs-s/AHVAwepH7taalJTznS87N4lAoLIWh6H3CM_d1Zsy_m8VPgoi0x1xnXlMCAqr1RZtmtNgymHANXHbmAAdfBTO1G40Su-21IOoNBNxjIbFMBtXWL8Bgt3BgJ9vPEPWEpZmKzMcpi-EL0f_7g=w1600-h1200",
      "https://lh3.googleusercontent.com/gps-cs-s/AHVAweqgwnSCluHmtxAudWmtD9OLW27ssqpVRjEBkr5RCd_sqtCksMAcfDKAqR4MyqxNf38Wq5oTpcX4PWnHDKKCsJW3DG9X81dQ7jPlr1wPRIFplL9oi3JEY2Uz_ssxbef5nJst2rM=w1600-h1200"
    ]
  },
  {
    "id": "patagonia-estetica-gral-roca-rn",
    "listingType": "clinica",
    "name": "Patagonia Estética",
    "isFeatured": false,
    "tier": 1,
    "description": "Clínica de estética integral en General Roca. Ofrece tratamientos faciales, corporales y depilación láser con tecnología moderna.",
    "specialties": [
      "Depilación Láser",
      "Tratamientos Faciales",
      "Tratamientos Corporales",
      "Radiofrecuencia"
    ],
    "city": "General Roca",
    "province": "Río Negro",
    "experience": "7+ años",
    "hours": "Lunes a Viernes 09:00-19:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 298 4432100",
      "email": "contacto@patagoniaestetica.com.ar",
      "whatsapp": "https://wa.me/5492984432100",
      "website": "https://patagoniaestetica.com.ar"
    },
    "address": "Belgrano 1234, General Roca, Río Negro",
    "images": [
      "https://placehold.co/400x250/D0021B/FFFFFF?text=Patagonia+Estetica",
      "https://placehold.co/400x250/9013FE/FFFFFF?text=General+Roca"
    ]
  },
  {
    "id": "armonizza-estetica-catamarca",
    "listingType": "clinica",
    "name": "Armonizza Estética Y Salud",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro oficial Soprano Ice con asesoramiento médico, PLEXR, HIFU, criolipólisis y tratamientos faciales y corporales integrales.",
    "specialties": ["Depilación Láser", "Hilos Tensores", "Radiofrecuencia", "Tratamientos Faciales", "Criolipólisis"],
    "city": "San Fernando del Valle de Catamarca",
    "province": "Catamarca",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 9:00-19:00, Sábado 9:00-13:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 383 471-8825",
      "email": "info@armonizza.com.ar",
      "whatsapp": "https://wa.me/5493834718825",
      "website": "https://www.instagram.com/eysarmonizza"
    },
    "address": "Av. Pres. Castillo 1597, San Fernando del Valle de Catamarca, Catamarca",
    "additionalServices": ["Consultas Médicas Especializadas", "Planes de Tratamiento Personalizados", "Seguimiento Post-Tratamiento"],
    "calendarLink": "https://calendly.com/armonizza-estetica",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": [
      "https://lh3.googleusercontent.com/p/AF1QipOyVQYBosAbLCcP3YW7RgdY_Ajyu9Do8jExD6oN=w1600-h1200",
      "https://lh3.googleusercontent.com/p/AF1QipOEUCIVOi27bDLuZHLC7fwCErzGMgEPKbHg88tG=w1600-h1200"
    ]
  },
  {
    "id": "noa-estetica-premium-catamarca",
    "listingType": "spa",
    "name": "Noa Estética Premium",
    "isFeatured": false,
    "tier": 2,
    "description": "Especialistas en depilación láser definitiva. Único centro oficial Soprano en Catamarca con VelaShape3, Venus Legacy y tratamientos premium.",
    "specialties": ["Depilación Láser", "VelaShape3", "Venus Legacy", "Tratamientos Corporales", "Cavitación"],
    "city": "San Fernando del Valle de Catamarca",
    "province": "Catamarca",
    "experience": "8+ años",
    "hours": "Lunes a Sábado 9:00-20:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 3834 64-7145",
      "email": "contacto@noaestetica.com.ar",
      "whatsapp": "https://wa.me/5493834647145",
      "website": "https://www.instagram.com/lasernoaok"
    },
    "address": "Esquiú 841, San Fernando del Valle de Catamarca, Catamarca",
    "images": ["https://placehold.co/400x250/4A90E2/FFFFFF?text=Noa+Estética+Premium", "https://placehold.co/400x250/5DADE2/FFFFFF?text=Depilación+Soprano", "https://placehold.co/400x250/85C1E9/FFFFFF?text=Venus+Legacy"]
  },
  {
    "id": "davana-estilo-catamarca",
    "listingType": "salon",
    "name": "Davana Estilo",
    "isFeatured": false,
    "tier": 1,
    "description": "Salón unisex con servicios integrales de belleza y estética. Ambiente relajante para el cuidado personal completo.",
    "specialties": ["Cortes y Peinados", "Manicuría y Pedicuría", "Tratamientos Faciales", "Depilación con Cera"],
    "city": "San Fernando del Valle de Catamarca",
    "province": "Catamarca",
    "experience": "5+ años",
    "hours": "Lunes a Sábado 9:00-21:00",
    "rating": 4.2,
    "contact": {
      "phone": "+54 3834 631200",
      "email": "davana@estilo.com.ar",
      "whatsapp": "https://wa.me/5493834631200",
      "website": "https://www.facebook.com/DavanaCatamarca"
    },
    "address": "República 779, San Fernando del Valle de Catamarca, Catamarca",
    "images": ["https://placehold.co/400x250/F39C12/FFFFFF?text=Davana+Estilo", "https://placehold.co/400x250/E67E22/FFFFFF?text=Salón+Unisex"]
  },
  {
    "id": "morena-centro-estetica-parana",
    "listingType": "clinica",
    "name": "Morena Centro de Estética",
    "isFeatured": true,
    "tier": 2,
    "description": "Centro integral con tratamientos corporales, faciales y nutrición. Circuitos personalizados con tecnología avanzada en aparatología.",
    "specialties": ["Tratamientos Corporales", "Tratamientos Faciales", "Nutrición", "Drenaje Linfático", "Maderoterapia"],
    "city": "Paraná",
    "province": "Entre Ríos",
    "experience": "7+ años",
    "hours": "Lunes a Viernes 8:00-19:00, Sábado 9:00-15:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 343 464-3067",
      "email": "turnos@morenaestetica.com.ar",
      "whatsapp": "https://wa.link/7layae",
      "website": "https://www.instagram.com/morenacentrodeestetica"
    },
    "address": "Almafuerte 403, Paraná, Entre Ríos",
    "images": ["https://placehold.co/400x250/8E44AD/FFFFFF?text=Morena+Centro", "https://placehold.co/400x250/A569BD/FFFFFF?text=Tratamientos+Integrales"]
  },
  {
    "id": "rita-bastian-estetica-colon",
    "listingType": "medicina-estetica",
    "name": "Rita Bastian Estética Láser",
    "isFeatured": false,
    "tier": 1,
    "description": "Dermatocosmiatra especializada en medicina estética aplicada. Tratamientos láser, radiofrecuencia fraccionada y procedimientos anti-age.",
    "specialties": ["Terapia con Láser", "Radiofrecuencia", "Tratamientos Anti-Age", "Dermatología Estética"],
    "city": "Colón",
    "province": "Entre Ríos",
    "experience": "12+ años",
    "hours": "Lunes a Viernes 14:00-19:00",
    "rating": 4.4,
    "contact": {
      "phone": "+54 3447 498559",
      "email": "ritabastian@estetica.com.ar",
      "whatsapp": "https://wa.me/5493447498559",
      "website": "https://www.facebook.com/RitaBastianEstetica"
    },
    "address": "Alberdi 501, Colón, Entre Ríos",
    "images": [
      "https://www.colonturismo.tur.ar/wp-content/uploads/2025/07/WhatsApp-Image-2025-07-09-at-14.57.14.jpeg",
      "https://www.colonturismo.tur.ar/wp-content/uploads/2025/07/WhatsApp-Image-2025-07-09-at-14.57.33.jpeg",
      "https://www.colonturismo.tur.ar/wp-content/uploads/2025/07/WhatsApp-Image-2025-07-09-at-15.04.10.jpeg"
    ]
  },
  {
    "id": "estetica-integral-parana",
    "listingType": "spa",
    "name": "Centro de Estética Integral",
    "isFeatured": false,
    "tier": 1,
    "description": "Spa urbano con circuitos de relajación y tratamientos corporales. Especializado en bienestar integral y estética natural.",
    "specialties": ["Masajes Terapéuticos", "Rituales de Aromaterapia", "Hidroterapia", "Bienestar"],
    "city": "Paraná",
    "province": "Entre Ríos",
    "experience": "6+ años",
    "hours": "Lunes a Sábado 9:00-18:00",
    "rating": 4.3,
    "contact": {
      "phone": "+54 343 431-2580",
      "email": "info@esteticaintegral.com.ar",
      "whatsapp": "https://wa.me/5493434312580",
      "website": "https://www.esteticaintegral.com.ar"
    },
    "address": "Santa Fe 70, Paraná, Entre Ríos",
    "images": ["https://placehold.co/400x250/3498DB/FFFFFF?text=Estética+Integral", "https://placehold.co/400x250/5DADE2/FFFFFF?text=Spa+Relajación"]
  },
  {
    "id": "cemer-medicina-estetica-jujuy",
    "listingType": "medicina-estetica",
    "name": "CEMER - Centro de Medicina Estética y Reparadora",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro médico especializado con tecnología de última generación. Más de 10 años de experiencia en medicina estética y cirugía plástica.",
    "specialties": ["Inyectables y Rellenos", "Botox", "Depilación Láser", "Cirugía Plástica", "Plasma Rico en Plaquetas"],
    "city": "San Salvador de Jujuy",
    "province": "Jujuy",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 8:30-12:30 y 16:00-20:30",
    "rating": 4.8,
    "contact": {
      "phone": "+54 388 422-6622",
      "email": "turnos@cemer.com.ar",
      "whatsapp": "https://wa.me/5493884226622",
      "website": "https://www.cemer.com.ar"
    },
    "address": "Pje. Dr. Ernesto Claros 21, San Salvador de Jujuy, Jujuy",
    "additionalServices": ["Consultas Médicas Especializadas", "Seguimiento Post-Quirúrgico", "Planes de Financiación", "Telemedicina"],
    "calendarLink": "https://www.cemer.com.ar/turnos-online",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": ["https://placehold.co/400x250/E74C3C/FFFFFF?text=CEMER+Medicina", "https://placehold.co/400x250/C0392B/FFFFFF?text=Tecnología+Avanzada", "https://placehold.co/400x250/EC7063/FFFFFF?text=Cirugía+Estética"]
  },
  {
    "id": "soler-clinica-estetica-jujuy",
    "listingType": "clinica",
    "name": "SOLER Clínica Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Clínica con procedimientos y servicios profesionales. Aceptamos obras sociales y atención particular con tecnología moderna.",
    "specialties": ["Armonización Facial", "Toxina Botulínica", "Tratamientos Faciales", "Bioestimulación"],
    "city": "San Salvador de Jujuy",
    "province": "Jujuy",
    "experience": "8+ años",
    "hours": "Martes a Miércoles 16:00-20:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 388 426-3809",
      "email": "consultas@solerclinica.com.ar",
      "whatsapp": "https://wa.me/5493884620118",
      "website": "https://www.instagram.com/soler_clinicaestetica"
    },
    "address": "Av. Arturo Illia 563 - Los Perales, San Salvador de Jujuy, Jujuy",
    "images": ["https://placehold.co/400x250/9B59B6/FFFFFF?text=SOLER+Clínica", "https://placehold.co/400x250/BB8FCE/FFFFFF?text=Armonización+Facial"]
  },
  {
    "id": "elite-medicina-estetica-jujuy",
    "listingType": "medicina-estetica",
    "name": "Élite Medicina Estética",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro médico estético con atención personalizada. Especializado en tratamientos no invasivos y procedimientos estéticos avanzados.",
    "specialties": ["Mesoterapia", "Bioestimulación", "Peelings Químicos", "Microneedling"],
    "city": "San Salvador de Jujuy",
    "province": "Jujuy",
    "experience": "5+ años",
    "hours": "Lunes a Viernes 8:30-12:30 y 16:00-20:30",
    "rating": 4.2,
    "contact": {
      "phone": "+54 388 471-1400",
      "email": "elite@medicinaestetica.com.ar",
      "whatsapp": "https://wa.me/5493884711400",
      "website": "https://www.facebook.com/EliteMedicinaEstetica"
    },
    "address": "Centro, San Salvador de Jujuy, Jujuy",
    "images": ["https://placehold.co/400x250/34495E/FFFFFF?text=Élite+Medicina", "https://placehold.co/400x250/5D6D7E/FFFFFF?text=Tratamientos+Médicos"]
  },
  {
    "id": "quimera-estetica-san-luis",
    "listingType": "spa",
    "name": "Quimera Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Especialistas en el cuidado de tu belleza con tratamientos personalizados para resaltar tu mejor versión en un ambiente de relajación.",
    "specialties": ["Tratamientos Corporales", "Tratamientos Faciales", "Limpieza Facial", "Masajes Terapéuticos"],
    "city": "San Luis",
    "province": "San Luis",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 9:00-18:00, Sábado 9:00-14:00",
    "rating": 4.4,
    "contact": {
      "phone": "+54 2664 316649",
      "email": "turnos@quimeraestetica.com.ar",
      "whatsapp": "https://wa.me/5492664316649",
      "website": "https://www.instagram.com/quimeraesteticasl"
    },
    "address": "Pedernera 1064, San Luis, San Luis",
    "images": ["https://placehold.co/400x250/16A085/FFFFFF?text=Quimera+Estética", "https://placehold.co/400x250/48C9B0/FFFFFF?text=Belleza+Natural"]
  },
  {
    "id": "pandora-belleza-rostro-san-luis",
    "listingType": "salon",
    "name": "Pandora Belleza de Rostro",
    "isFeatured": false,
    "tier": 1,
    "description": "Especialistas en perfeccionar la belleza de tu mirada. Centro dedicado al cuidado estético facial y embellecimiento de cejas y pestañas.",
    "specialties": ["Estética de Pestañas y Cejas", "Tratamientos Faciales", "Limpieza Facial", "Consultas Personalizadas"],
    "city": "San Luis",
    "province": "San Luis",
    "experience": "4+ años",
    "hours": "Martes a Sábado 9:00-17:00",
    "rating": 4.3,
    "contact": {
      "phone": "+54 2664 425180",
      "email": "pandora@belleza.com.ar",
      "whatsapp": "https://wa.me/5492664425180",
      "website": "https://www.facebook.com/PandoraBellezaDeRostro"
    },
    "address": "Centro, San Luis, San Luis",
    "images": ["https://placehold.co/400x250/E67E22/FFFFFF?text=Pandora+Belleza", "https://placehold.co/400x250/F39C12/FFFFFF?text=Belleza+Mirada"]
  },
  {
    "id": "estilo-abigail-peluqueria-san-luis",
    "listingType": "salon",
    "name": "Estilo Abigail Peluquería",
    "isFeatured": false,
    "tier": 1,
    "description": "Salon especializado en mejorar la salud y estética capilar desde 2007. Enfoque integral en el cuidado del cabello y imagen personal.",
    "specialties": ["Cortes y Peinados", "Tratamientos Capilares", "Coloración", "Consultas Personalizadas"],
    "city": "San Luis",
    "province": "San Luis",
    "experience": "17+ años",
    "hours": "Lunes a Viernes 9:00-19:00, Sábado 9:00-16:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 2664 442356",
      "email": "contacto@estiloabigail.com.ar",
      "whatsapp": "https://wa.me/5492664442356",
      "website": "https://www.estiloabigail.com.ar"
    },
    "address": "Centro, San Luis, San Luis",
    "images": ["https://placehold.co/400x250/D35400/FFFFFF?text=Estilo+Abigail", "https://placehold.co/400x250/E67E22/FFFFFF?text=Salud+Capilar"]
  },
  {
    "id": "barrau-estetica-salud-santa-rosa",
    "listingType": "clinica",
    "name": "Barrau Estética y Salud",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro de estética integral con 15 años de experiencia. Instalaciones de primer nivel con equipos de avanzada y profesionales especializados.",
    "specialties": ["Tratamientos Corporales", "Tratamientos Faciales", "Depilación Láser", "Radiofrecuencia", "Consultas Personalizadas"],
    "city": "Santa Rosa",
    "province": "La Pampa",
    "experience": "15+ años",
    "hours": "Lunes a Viernes 9:00-19:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 2954 45-7384",
      "email": "contacto@lorenabarrau.com",
      "whatsapp": "https://wa.me/5492954457384",
      "website": "https://www.lorenabarrau.com"
    },
    "address": "Gral. Güemes 36, Santa Rosa, La Pampa",
    "additionalServices": ["Consultorios Médicos", "Planes de Tratamiento Integral", "Seguimiento Personalizado", "Tecnología de Vanguardia"],
    "calendarLink": "https://www.lorenabarrau.com/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": ["https://placehold.co/400x250/8E44AD/FFFFFF?text=Barrau+Estética", "https://placehold.co/400x250/A569BD/FFFFFF?text=15+Años+Experiencia", "https://placehold.co/400x250/BB8FCE/FFFFFF?text=Tecnología+Avanzada"]
  },
  {
    "id": "saluderm-medicina-estetica-santa-rosa",
    "listingType": "medicina-estetica",
    "name": "Saluderm Medicina Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Centro médico de excelencia especializado en medicina estética. Tratamientos faciales, corporales y terapias láser con tecnología Harmony XL Pro.",
    "specialties": ["Terapia con Láser", "Tratamientos Faciales", "Tratamientos Corporales", "Dermatología Estética"],
    "city": "Santa Rosa",
    "province": "La Pampa",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 9:00-18:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 2954 58-8666",
      "email": "turnos@saluderm.com.ar",
      "whatsapp": "https://wa.me/5492954588666",
      "website": "https://www.instagram.com/saluderm_medicina.estetica"
    },
    "address": "Av. Uruguay 867, Santa Rosa, La Pampa",
    "images": ["https://placehold.co/400x250/2980B9/FFFFFF?text=Saluderm+Medicina", "https://placehold.co/400x250/3498DB/FFFFFF?text=Harmony+XL+Pro"]
  },
  {
    "id": "sofia-bobillo-medicina-estetica-santa-rosa",
    "listingType": "medicina-estetica",
    "name": "SB Medicina Estética - Dra. Sofía Bobillo",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro especializado en rejuvenecimiento facial con los mejores tratamientos diseñados por equipo médico. Biomodelación y tecnología mundial.",
    "specialties": ["Tratamientos Anti-Age", "Bioestimulación", "Inyectables y Rellenos", "Mesolifting"],
    "city": "Santa Rosa",
    "province": "La Pampa",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 14:00-19:00",
    "rating": 4.4,
    "contact": {
      "phone": "+54 2954 435672",
      "email": "consultas@drasofiabobillo.com",
      "whatsapp": "https://wa.me/5492954435672",
      "website": "https://www.drasofiabobillo.com"
    },
    "address": "Centro, Santa Rosa, La Pampa",
    "images": ["https://placehold.co/400x250/E74C3C/FFFFFF?text=SB+Medicina", "https://placehold.co/400x250/C0392B/FFFFFF?text=Rejuvenecimiento"]
  },
  {
    "id": "dyme-dermatologia-medicina-estetica-bariloche",
    "listingType": "medicina-estetica",
    "name": "DyME - Dermatología y Medicina Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro médico especializado en dermatología y medicina estética en Patagonia. Tecnología de vanguardia y profesionales altamente capacitados.",
    "specialties": ["Dermatología Estética", "Inyectables y Rellenos", "Botox", "Tratamientos Anti-Age", "Consultas Personalizadas"],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "12+ años",
    "hours": "Jueves 10:30-12:30 y 13:30-19:00, Viernes 10:30-12:30 y 13:30-19:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 294 443-3077",
      "email": "info@dymeargentina.com",
      "whatsapp": "https://wa.me/5492944433077",
      "website": "http://dymeargentina.com/es/"
    },
    "address": "Rolando 430, San Carlos de Bariloche, Río Negro",
    "additionalServices": ["Consultas Médicas Especializadas", "Seguimiento Post-Tratamiento", "Protocolos Personalizados", "Tecnología de Última Generación"],
    "calendarLink": "http://dymeargentina.com/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": ["https://placehold.co/400x250/2C3E50/FFFFFF?text=DyME+Medicina", "https://placehold.co/400x250/34495E/FFFFFF?text=Dermatología+Avanzada", "https://placehold.co/400x250/5D6D7E/FFFFFF?text=Patagonia+Estética"]
  },
  {
    "id": "spa-del-sur-bariloche",
    "listingType": "spa",
    "name": "Spa del Sur",
    "isFeatured": false,
    "tier": 2,
    "description": "Spa terapéutico holístico con enfoque en prevención y calidad de vida. Ambiente relajante con servicios integrales de bienestar.",
    "specialties": ["Masajes Terapéuticos", "Bienestar", "Rituales de Aromaterapia", "Hidroterapia", "Terapias Alternativas"],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 10:00-19:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 294 458-1095",
      "email": "info@spadelsur.com.ar",
      "whatsapp": "https://wa.me/5492944581095",
      "website": "https://spadelsur.com.ar"
    },
    "address": "Beschtedt 710 esquina Albarracín, San Carlos de Bariloche, Río Negro",
    "images": ["https://placehold.co/400x250/27AE60/FFFFFF?text=Spa+del+Sur", "https://placehold.co/400x250/2ECC71/FFFFFF?text=Terapias+Holísticas"]
  },
  {
    "id": "estetica-geraldin-bariloche",
    "listingType": "clinica",
    "name": "Estética Geraldin",
    "isFeatured": false,
    "tier": 2,
    "description": "Centro integral con muchos años de trayectoria en Bariloche. Profesionales de primer nivel y equipamiento moderno para diagnósticos y tratamientos.",
    "specialties": ["Depilación Láser", "Drenaje Linfático", "Radiofrecuencia", "Tratamientos Corporales", "Peelings Químicos"],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "15+ años",
    "hours": "Lunes a Sábado 9:00-19:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 294 442-8956",
      "email": "turnos@esteticageraldin.com.ar",
      "whatsapp": "https://wa.me/5492944428956",
      "website": "https://www.facebook.com/EsteticaIntegralGeraldin"
    },
    "address": "Av. Ángel Gallardo 142, San Carlos de Bariloche, Río Negro",
    "images": ["https://placehold.co/400x250/8E44AD/FFFFFF?text=Estética+Geraldin", "https://placehold.co/400x250/A569BD/FFFFFF?text=15+Años+Experiencia"]
  },
  {
    "id": "cristina-brandizzi-estetica-bariloche",
    "listingType": "salon",
    "name": "Cristina Brandizzi Estética",
    "isFeatured": false,
    "tier": 1,
    "description": "Estética masculina y femenina con sistema de depilación láser indolora Trío Ice. Tratamientos corporales y faciales personalizados.",
    "specialties": ["Depilación Láser", "Tratamientos Faciales", "Tratamientos Corporales", "Estética de Pestañas y Cejas"],
    "city": "San Carlos de Bariloche",
    "province": "Río Negro",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 9:00-18:00, Sábado 9:00-15:00",
    "rating": 4.4,
    "contact": {
      "phone": "+54 294 456-7890",
      "email": "cristinabrandizzi@estetica.com.ar",
      "whatsapp": "https://wa.me/5492944567890",
      "website": "https://www.instagram.com/esteticabariloche"
    },
    "address": "Tiscornia 233, San Carlos de Bariloche, Río Negro",
    "images": ["https://placehold.co/400x250/E67E22/FFFFFF?text=Cristina+Brandizzi", "https://placehold.co/400x250/F39C12/FFFFFF?text=Depilación+Trío+Ice"]
  },
  {
    "id": "piu-bella-estetica-puerto-iguazu",
    "listingType": "spa",
    "name": "PIU BELLA Estética Avanzada",
    "isFeatured": true,
    "tier": 2,
    "description": "Centro de estética y wellness con tratamientos premium. Experiencia única para tu bienestar con tecnología avanzada y atención personalizada.",
    "specialties": ["Tratamientos Faciales", "Armonización Facial", "Dermatología Estética", "Bioestimulación", "Bienestar"],
    "city": "Puerto Iguazú",
    "province": "Misiones",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 9:00-21:00, Sábado 10:00-18:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 3757 523581",
      "email": "contacto@piubella.com.ar",
      "whatsapp": "https://wa.me/5493757523581",
      "website": "https://www.instagram.com/piubellaigr"
    },
    "address": "Guaraní 57, Puerto Iguazú, Misiones",
    "images": ["https://placehold.co/400x250/16A085/FFFFFF?text=PIU+BELLA", "https://placehold.co/400x250/48C9B0/FFFFFF?text=Estética+Premium"]
  },
  {
    "id": "bienestar-salud-belleza-puerto-iguazu",
    "listingType": "clinica",
    "name": "Bienestar, Salud y Belleza",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro especializado en medicina estética, cosmetología y antienvejecimiento. Personal altamente calificado con experiencia personalizada única.",
    "specialties": ["Drenaje Linfático", "Tratamientos Faciales", "Cavitación", "Estética de Pestañas y Cejas", "Masajes Terapéuticos"],
    "city": "Puerto Iguazú",
    "province": "Misiones",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 9:00-21:00, Sábado 16:00-21:00",
    "rating": 4.7,
    "contact": {
      "phone": "+54 3764 609017",
      "email": "contacto@bienestarsaludybellezaiguazu.com",
      "whatsapp": "https://wa.me/5493764609017",
      "website": "https://www.bienestarsaludybellezaiguazu.com"
    },
    "address": "Marta Schwarz 81, Puerto Iguazú, Misiones",
    "additionalServices": ["Tratamientos Antienvejecimiento", "Programas de Bienestar Integral", "Consultas Nutricionales", "Seguimiento Personalizado"],
    "calendarLink": "https://www.bienestarsaludybellezaiguazu.com/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": ["https://placehold.co/400x250/3498DB/FFFFFF?text=Bienestar+Salud", "https://placehold.co/400x250/5DADE2/FFFFFF?text=Medicina+Estética", "https://placehold.co/400x250/85C1E9/FFFFFF?text=Antienvejecimiento"]
  },
  {
    "id": "gema-centro-estetica-puerto-iguazu",
    "listingType": "spa",
    "name": "Gema Centro de Estética Integral",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro integral de estética y spa capilar. Especializado en tratamientos de belleza y cuidado capilar con atención personalizada.",
    "specialties": ["Tratamientos Capilares", "Tratamientos Faciales", "Spa Capilar", "Limpieza Facial"],
    "city": "Puerto Iguazú",
    "province": "Misiones",
    "experience": "5+ años",
    "hours": "Martes a Viernes 14:00-21:00, Sábado 10:00-18:00",
    "rating": 4.3,
    "contact": {
      "phone": "+54 3757 523581",
      "email": "gema@esteticaintegral.com.ar",
      "whatsapp": "https://wa.me/5493757523581",
      "website": "https://www.facebook.com/Gemacentrdebellezayspacapilar"
    },
    "address": "Av. República Argentina 142, Puerto Iguazú, Misiones",
    "images": ["https://placehold.co/400x250/E74C3C/FFFFFF?text=Gema+Centro", "https://placehold.co/400x250/C0392B/FFFFFF?text=Spa+Capilar"]
  },
  {
    "id": "sbelle-estetica-puerto-iguazu",
    "listingType": "salon",
    "name": "Sbelle Estética Fisioterapia",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro que combina estética y fisioterapia. Enfoque integral en salud y belleza con tratamientos especializados y personalizados.",
    "specialties": ["Tratamientos Corporales", "Fisioterapia Estética", "Masajes Terapéuticos", "Rehabilitación"],
    "city": "Puerto Iguazú",
    "province": "Misiones",
    "experience": "4+ años",
    "hours": "Lunes a Viernes 8:00-18:00",
    "rating": 4.2,
    "contact": {
      "phone": "+54 3757 425418",
      "email": "sbelle@fisioterapia.com.ar",
      "whatsapp": "https://wa.me/5493757425418",
      "website": "https://www.sbelleestetica.com.ar"
    },
    "address": "Avenida Brasil 44, Puerto Iguazú, Misiones",
    "images": ["https://placehold.co/400x250/9B59B6/FFFFFF?text=Sbelle+Estética", "https://placehold.co/400x250/BB8FCE/FFFFFF?text=Fisioterapia+Integral"]
  },
  {
    "id": "instituto-austral-mendoza",
    "listingType": "medicina-estetica",
    "name": "Instituto Austral - Medicina Estética",
    "isFeatured": true,
    "tier": 3,
    "description": "Centro médico integral con medicina estética de vanguardia. Biomodelación facial, técnicas MD Codes y línea de productos BOU exclusiva.",
    "specialties": ["Inyectables y Rellenos", "Toxina Botulínica", "Hilos Tensores", "Armonización Facial", "Bioestimulación"],
    "city": "Mendoza",
    "province": "Mendoza",
    "experience": "15+ años",
    "hours": "Lunes y Viernes 8:00-19:00, Martes y Miércoles 8:00-18:00, Jueves y Sábado 8:00-13:00",
    "rating": 4.8,
    "contact": {
      "phone": "+54 261 423-5884",
      "email": "info@institutoaustral.com",
      "whatsapp": "https://wa.me/5492616835489",
      "website": "https://institutoaustral.com"
    },
    "address": "Montevideo 708 y 718, Mendoza, Mendoza",
    "additionalServices": ["Consultas Médicas Especializadas", "Línea de Productos BOU", "Videoconsultas", "Recetas Digitales"],
    "calendarLink": "https://institutoaustral.com/turnos",
    "crmAccess": true,
    "socialMediaManagement": true,
    "images": ["https://placehold.co/400x250/E74C3C/FFFFFF?text=Instituto+Austral", "https://placehold.co/400x250/C0392B/FFFFFF?text=Medicina+Avanzada", "https://placehold.co/400x250/EC7063/FFFFFF?text=Técnicas+MD"]
  },
  {
    "id": "dhermasalud-medicina-estetica-mendoza",
    "listingType": "medicina-estetica",
    "name": "DhermaSalud - Medicina Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Dermatología de avanzada especializada en medicina estética. Tratamientos para rejuvenecimiento facial, flacidez corporal y adiposidad localizada.",
    "specialties": ["Depilación Láser", "Tratamientos Anti-Age", "Radiofrecuencia", "Láser Fraccionado", "Tratamientos Corporales"],
    "city": "Mendoza",
    "province": "Mendoza",
    "experience": "10+ años",
    "hours": "Lunes a Viernes 9:00-18:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 261 610-6180",
      "email": "consultas@dhermasalud.com.ar",
      "whatsapp": "https://wa.me/5492616106180",
      "website": "https://www.dhermasalud.com.ar"
    },
    "address": "Centro, Mendoza, Mendoza",
    "images": ["https://placehold.co/400x250/2980B9/FFFFFF?text=DhermaSalud", "https://placehold.co/400x250/3498DB/FFFFFF?text=Dermatología+Avanzada"]
  },
  {
    "id": "clinica-claire-mendoza",
    "listingType": "clinica",
    "name": "Clínica Claire - Medicina Estética",
    "isFeatured": false,
    "tier": 2,
    "description": "Clínica especializada en medicina estética no invasiva. Tratamientos para envejecimiento cutáneo, flacidez, arrugas y modelado corporal.",
    "specialties": ["Tratamientos Anti-Age", "Modelado Corporal", "Tratamientos para Estrías", "Tensado de Piel", "Peelings Químicos"],
    "city": "Mendoza",
    "province": "Mendoza",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 8:30-18:30, Sábado 9:00-13:00",
    "rating": 4.5,
    "contact": {
      "phone": "+54 261 425-7890",
      "email": "info@claireclinica.com",
      "whatsapp": "https://wa.me/5492614257890",
      "website": "https://www.claireclinica.com"
    },
    "address": "Centro, Mendoza, Mendoza",
    "images": ["https://placehold.co/400x250/8E44AD/FFFFFF?text=Clínica+Claire", "https://placehold.co/400x250/A569BD/FFFFFF?text=Modelado+Corporal"]
  },
  {
    "id": "centro-estetica-ser-mendoza",
    "listingType": "salon",
    "name": "Centro de Estética SER",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro con tratamientos de última generación atendido por profesionales especializados. Kinesiología y estética integral en Maipú.",
    "specialties": ["Tratamientos Corporales", "Kinesiología Estética", "Tratamientos Faciales", "Drenaje Linfático"],
    "city": "Mendoza",
    "province": "Mendoza",
    "experience": "6+ años",
    "hours": "Lunes a Viernes 9:00-19:00, Sábado 9:00-15:00",
    "rating": 4.3,
    "contact": {
      "phone": "+54 261 497-6543",
      "email": "turnos@centroesteticaser.com.ar",
      "whatsapp": "https://wa.me/5492614976543",
      "website": "https://www.instagram.com/serkinesiologiayestetica"
    },
    "address": "Paseo Distrito Comercial, Local 26, Maipú, Mendoza",
    "images": ["https://placehold.co/400x250/27AE60/FFFFFF?text=Centro+SER", "https://placehold.co/400x250/2ECC71/FFFFFF?text=Kinesiología+Estética"]
  },
  {
    "id": "vz-espacio-estetica-spa-salta",
    "listingType": "spa",
    "name": "VZ Espacio Estética & Spa",
    "isFeatured": true,
    "tier": 2,
    "description": "Spa con dos sucursales en Salta. Amplia gama de servicios de estética y bienestar con productos profesionales y atención especializada.",
    "specialties": ["Tratamientos Faciales", "Tratamientos Corporales", "Masajes Terapéuticos", "Bienestar", "Rituales de Aromaterapia"],
    "city": "Salta",
    "province": "Salta",
    "experience": "9+ años",
    "hours": "Lunes a Viernes 9:00-20:00, Sábado 9:00-17:00",
    "rating": 4.6,
    "contact": {
      "phone": "+54 387 455-9364",
      "email": "info@vzespacioestetica.com.ar",
      "whatsapp": "https://wa.me/5493874559364",
      "website": "https://www.instagram.com/vzespacioestetica"
    },
    "address": "Pasaje Klein 50 (Central), Salta, Salta",
    "images": ["https://placehold.co/400x250/9B59B6/FFFFFF?text=VZ+Espacio", "https://placehold.co/400x250/BB8FCE/FFFFFF?text=Spa+Integral"]
  },
  {
    "id": "sr-estetica-salud-integral-salta",
    "listingType": "clinica",
    "name": "SR Estética y Salud Integral",
    "isFeatured": false,
    "tier": 1,
    "description": "Centro de estética y salud integral con enfoque holístico. Tratamientos personalizados para el cuidado completo de la persona.",
    "specialties": ["Tratamientos Integrales", "Bienestar", "Consultas Personalizadas", "Nutrición"],
    "city": "Salta",
    "province": "Salta",
    "experience": "7+ años",
    "hours": "Lunes a Viernes 9:00-18:00",
    "rating": 4.4,
    "contact": {
      "phone": "+54 387 421-3456",
      "email": "contacto@sresteticasalta.com.ar",
      "whatsapp": "https://wa.me/5493874213456",
      "website": "https://www.facebook.com/SREsteticaySaludIntegral"
    },
    "address": "Centro, Salta, Salta",
    "images": ["https://placehold.co/400x250/34495E/FFFFFF?text=SR+Estética", "https://placehold.co/400x250/5D6D7E/FFFFFF?text=Salud+Integral"]
  },
  {
    "id": "estetica-marcela-zelaya-salta",
    "listingType": "salon",
    "name": "Estética MZ - Marcela Zelaya",
    "isFeatured": false,
    "tier": 1,
    "description": "Salón de estética personalizado con tratamientos faciales y corporales. Atención especializada en un ambiente acogedor y profesional.",
    "specialties": ["Tratamientos Faciales", "Limpieza Facial", "Manicuría y Pedicuría", "Depilación con Cera"],
    "city": "Salta",
    "province": "Salta",
    "experience": "8+ años",
    "hours": "Lunes a Viernes 9:00-19:00, Sábado 9:00-16:00",
    "rating": 4.2,
    "contact": {
      "phone": "+54 387 456-7891",
      "email": "marcelazelaya@estetica.com.ar",
      "whatsapp": "https://wa.me/5493874567891",
      "website": "https://www.instagram.com/esteticamarcelazelaya"
    },
    "address": "Centro, Salta, Salta",
    "images": ["https://placehold.co/400x250/E67E22/FFFFFF?text=Estética+MZ", "https://placehold.co/400x250/F39C12/FFFFFF?text=Marcela+Zelaya"]
  }
];

export const listingTypes = {
  "clinica": "Clínicas Estéticas",
  "medicina-estetica": "Medicina Estética",
  "spa": "Spa y Bienestar",
  "salon": "Salones de Belleza"
};

